import { filter } from "./filter";
import { paging } from "./paging";

/**
 * ### Actualités
 * - Gestion de la page d'acutalités
 * - Fonction de filtres des actualités cf {filtrer}
 * - Fonction de pagination des informations cd { Paging}
 */

export const actualites = {
	container: '#actualites-list',

	init() {
		
		if (typeof jsonActualitesResult !== 'undefined') {
			
			this.originMarkup = document.querySelector('.actualites__pushs').innerHTML;
			this.jsonFiltered = jsonActualitesResult;
			
			// console.log (this.jsonFiltered);
			
			// INIT
			this.controllers();

			filter.init(); // initialisation de la fonction de filtre

			// FILTRAGE PAR LES FILTRES
			this.jsonFiltered = filter.updateJson(this.jsonFiltered);


			// INITIALISATION DU systeme de pagination
			paging.init(this.jsonFiltered, document.location.hash.substring(1) || 1, 10);
			
			// console.log (this.jsonFiltered);
			
			// si le numéro de page est trop grand
			if( parseInt(document.location.hash.substring(1)) > paging.datasPaginate.totalPages ){
				paging.init(this.jsonFiltered, 1 || 1, 10);
			}

			// ECOUTE LE CHANGEMENT DE PAGE DANS LA PAGINATION AVEC UN CUSTOM EVENT
			document.querySelector('.paging').addEventListener('currentPageChange', (e)=>{
				this.jsonFiltered = e.detail.json;
				this.render();
				// console.log(e.detail.pageNumber)
			})
		}
	}, 

	controllers(){

		// 1 - FILTRES
		// SOUMISSION DU BOUTON SUBMIT DANS FILTER

		document.querySelector('.filter').addEventListener('submit',  (e) => {
			e.preventDefault();
			this.jsonFiltered = filter.updateJson(jsonActualitesResult);

			// TO CLOSE ALL OPENED FILTERS
			let openedFilters = document.querySelectorAll('.filter__col.opened');
			if(openedFilters) {
				openedFilters.forEach(item => {
					filter.close(item);
				});
			}
			filter.flapFilters(false);

			paging.init(this.jsonFiltered, 1, 10);

			// RENDU AVEC LES NOUVELLES DONNÉES
			this.render();
		} );

	},

	render(){
		// console.log("render news json: ", this.jsonFiltered);
		let pushThumb = '';
	
		// SI PAS DE RESULTAT
		if(document.querySelector('.actualites__noresult')){
			if(this.jsonFiltered.length == 0){
				document.querySelector('.actualites__noresult').dataset.state = "visible";
			}
			else{
				document.querySelector('.actualites__noresult').dataset.state = "hidden";
			}
		}

		// AFFICHE LES RESULTATS
		this.jsonFiltered.forEach((actu) => {
			
			// console.log (actu);
			
			let myActu = new Actu(actu);
			pushThumb += myActu.markup;
		});
		
		document.querySelector(this.container).innerHTML = this.originMarkup + pushThumb;
	}
};


// Objet ACTU

class Actu {
	constructor({ date, filter_type, filter_periode, filter_thematique, timestamp, img_alt, img_url, title, link }) {
		this.thematique = this.classNames(filter_thematique);
		this.formats = this.classNames(filter_type);
		this.periode = this.classNames(filter_periode);

		this.markup = `
		<a href="${link}" class="push-thumb ${this.formats} ${this.periode} ${this.thematique}">
			<div class="push-thumb__img">
				<img src="${img_url}" alt="${img_alt}" />
			</div>
			<div class="push-thumb__content">
				<div class="push-thumb__subhead">
					<span class="push-thumb__subhead__date">${date}</span>
				</div>
				<div class="push-thumb__title">
					${title}
				</div>
			</div>
		</a>`;
	}

	classNames(string) {
		return string.replace(',', ' ');
	}
}
